import { ReactElement } from "react";
import { Tooltip } from "@mui/material";

export const TooltipContainer = (props: tooltipContainerProps) => {
  const placement = props.placement ?? "top-end";
  const enterDelay = props.enterDelay ?? 1000;
  const leaveDelay = props.leaveDelay ?? 200;
  const className = props.className ?? "tool-tip-text";
  return (
    <Tooltip
      title={
        props.content ? (
          props.content
        ) : (
          <span className={className}>{props.text}</span>
        )
      }
      placement={placement}
      enterDelay={enterDelay}
      leaveDelay={leaveDelay}
    >
      <div
        style={{
          display: "inline",
        }}
      >
        {props.children}
      </div>
    </Tooltip>
  );
};

interface tooltipContainerProps {
  text?: string | null | undefined;
  content?: ReactElement;
  children: ReactElement;
  className?: string;
  placement?: toolTipPlacement;
  enterDelay?: number;
  leaveDelay?: number;
}

export type toolTipPlacement =
  | "bottom-end"
  | "bottom-start"
  | "bottom"
  | "left-end"
  | "left-start"
  | "left"
  | "right-end"
  | "right-start"
  | "right"
  | "top-end"
  | "top-start"
  | "top";
